export class AuthParameter {
  passcodeAuth = false
  userAuth = false

  constructor(params?: Partial<AuthParameter>) {
    Object.assign(this, params)
  }
}
